import { h } from "preact";

import {
  stockMessage,
  monogramLeadTime,
} from "../helpers/stockMessage/stockMessage";

export default function StockMessage({ variant, monogram = null }) {
  if (!variant) return null;

  const message = stockMessage(variant);
  const monogramMessage = monogramLeadTime(monogram);

  if (!message && !monogramMessage) return null;

  return (
    <p className="product-form__stock-message">
      {[message, monogramMessage].filter(Boolean).join(" ")}
    </p>
  );
}
